import * as React from 'react';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Button from '@mui/material/Button';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { visuallyHidden } from '@mui/utils';
import TableSortLabel from '@mui/material/TableSortLabel';
import Box from '@mui/material/Box'
import FeedIcon from '@mui/icons-material/Feed';



const StickyHeadNoPaginationTable = ({ rows, columns, handleEdit, handleDelete, title, imageName }) => {
  const [order, setOrder] = React.useState('asc');
  const [orderBy, setOrderBy] = React.useState('');

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const createSortHandler = (property) => (event) => {
    handleRequestSort(event, property);
  };

  const descendingComparator = React.useCallback((a, b, orderBy) => {
      if (b[orderBy] < a[orderBy]) {
        return -1;
      }
      if (b[orderBy] > a[orderBy]) {
        return 1;
      }
      return 0;
  }, []);

  const getComparator = React.useCallback(() => {
    return order === 'desc'
        ? (a, b) => descendingComparator(a, b, orderBy)
        : (a, b) => -descendingComparator(a, b, orderBy);
  }, [descendingComparator,order,orderBy]);

  const visibleRows = React.useMemo(
    () =>
      stableSort(rows, getComparator(order, orderBy)),
    [rows, getComparator, order, orderBy],
  );

  function stableSort(array, comparator) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
      const order = comparator(a[0], b[0]);
      if (order !== 0) {
        return order;
      }
      return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
  }

  return (
    <>
    <Paper sx={{ width: '100%', overflow: 'hidden' }}>
      <TableContainer>
        <Table stickyHeader>
          <TableHead>
          <TableRow>
              <TableCell align="center" colSpan={2} sx={{ color:"white", bgcolor:"#406599" }}>
                System Image
              </TableCell>
              <TableCell align="center" colSpan={3} sx={{ color:"white", bgcolor:"#406599" }}>
                {imageName}
              </TableCell>
            </TableRow>
            <TableRow>
              {columns.map((column) => (
                <TableCell
                  key={column.id}
                  align={column.align}
                  sortDirection={orderBy === column.id ? order : false}
                  sx={{ minWidth: column.minWidth, color:"white", bgcolor:"#406599" }}
                >
                <TableSortLabel
                    active={orderBy === column.id}
                    direction={orderBy === column.id ? order : 'asc'}
                    onClick={createSortHandler(column.id)}
                  >
                    {column.label}
                    {orderBy === column.id ? (
                      <Box component="span" sx={visuallyHidden}>
                        {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                      </Box>
                    ) : null}
                </TableSortLabel>
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {visibleRows
              .map((row) => {
                let uuid = row.uuid;
                if (row.uuid === undefined) {
                  uuid = row.token;
                }
                return (
                  <TableRow hover role="checkbox" tabIndex={-1} key={uuid}>
                    {columns.map((column) => {
                      const value = row[column.id];
                      return (
                        <TableCell key={column.id} align={column.align}>
                        {typeof value === 'boolean'?
                          (value === false ? 'False':'True'):
                          (column.action?
                            (<div><Button onClick={() => handleEdit(uuid)}><EditIcon sx={{ color: "#406599",fontSize: 20 }}/></Button><Button onClick={() => handleDelete(uuid)}><DeleteIcon sx={{ color: "#406599", fontSize: 20 }}/></Button></div>):
                            (column.skip?(<div><Button onClick={() => handleEdit(uuid)}><FeedIcon sx={{ color: "#406599",fontSize: 20 }}/></Button><Button onClick={() => handleDelete(uuid)}><DeleteIcon sx={{ color: "#406599", fontSize: 20 }}/></Button></div>):(value)))}
                        </TableCell>
                      );
                    })}
                  </TableRow>
                );
              })}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
    </>
  );
}

export default StickyHeadNoPaginationTable;
